<template>
    <Tooltip :position :label>
        <template #content>
            <slot name="content"></slot>
        </template>
        <div
            class="tw-inline-block tw-text-right tw-underline tw-decoration-dashed tw-underline-offset-4 tw-decoration-1 tw-decoration-gray-400 tw-cursor-help"
        >
            <slot></slot>
        </div>
    </Tooltip>
</template>
<script setup>
import Tooltip from '@/js/components/Tooltip.vue';

defineProps({
    label: {
        type: String,
        required: false,
        default: null,
    },
    position: {
        type: String,
        default: 'top',
    },
});
</script>
